import { useEffect } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = [
    { name: "Resources", path: "" },
    { name: "Project Access", path: "project-access" },
    { name: "Roles", path: "roles" },
    { name: "Assets Management", path: "assets-management" },
    { name: "Contacts", path: "contacts" },
  ];

  // Runs once on mount only — restores the last-visited Settings tab.
  // Intentionally NOT re-run on navigation (see the effect below for that).
  useEffect(() => {
    const lastPath = sessionStorage.getItem("lastSettingsPath");
    const isOnDefaultPage = location.pathname === "/settings";

    if (isOnDefaultPage && lastPath) {
      navigate(lastPath, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem("lastSettingsPath", location.pathname);
  }, [location.pathname]);

  return (
    <div className="p-3 sm:p-6 bg-[#F5F7FB] min-h-screen">
      {/* Header */}
      <div className="bg-white rounded-xl p-4 sm:p-5">
        <h1 className="text-2xl sm:text-[32px] font-semibold text-black">Settings</h1>
        <p className="text-[14px] text-gray-500 mt-1">
          Manage Resources, Project Access, Roles, Notifications And Contacts.
        </p>
      </div>

      {/* Tabs */}
      <div className="top-0 bg-white rounded-xl mt-4 p-1 flex flex-wrap gap-1 z-10">
        {tabs.map((tab) => (
          <NavLink
            key={tab.name}
            to={tab.path}
            end={tab.path === ""}
            onClick={() => {}}
            className={({ isActive }) =>
              `flex-1 min-w-[120px] py-2 rounded-lg text-center text-xs sm:text-sm transition-all cursor-pointer ${
                isActive ? "bg-[#4253C7] text-white" : "text-gray-500"
              }`
            }
          >
            {tab.name}
          </NavLink>
        ))}
      </div>

      {/* Dynamic page content — no z-index here: a z-0 stacking context
          traps the sub-pages' drawers/modals below the topbar */}
      <div className="relative mt-4">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
